var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongformUl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M1.5 12c.78 0 1.42.59 1.493 1.355L3 13.5c0 .78-.59 1.42-1.355 1.493L1.5 15C.672 15 0 14.334 0 13.5c0-.78.59-1.42 1.355-1.493zM15 13v1H7v-1zM1.5 6c.78 0 1.42.59 1.493 1.355L3 7.5c0 .78-.59 1.42-1.355 1.493L1.5 9C.672 9 0 8.334 0 7.5c0-.78.59-1.42 1.355-1.493zM15 7v1H7V7zM1.5 0c.78 0 1.42.59 1.493 1.355L3 1.5c0 .78-.59 1.42-1.355 1.493L1.5 3C.672 3 0 2.334 0 1.5 0 .72.59.08 1.355.007zM15 1v1H7V1z"
})));
export default SvgLongformUl;